import { unwrap } from '@hive/api';
import { useEffect, useState } from 'react';
import { useSession } from '../../lib/session';

export type Brake = { active?: boolean; reason?: string; pulledBy?: string; pulledAt?: string; releasedBy?: string; releasedAt?: string };

/** Quem pode puxar e soltar o freio de emergência (o mesmo que o núcleo confere). */
export const canBrake = (can: (p: string) => boolean) => can('settings:admin') || can('agents:admin');

/** Estado do freio e contagem de decisões, conferidos a cada minuto (e quando `bump` muda). */
export function useOps(bump = 0) {
  const s = useSession();
  const [brake, setBrake] = useState<Brake | null>(null);
  const [count, setCount] = useState(0);
  useEffect(() => {
    let alive = true;
    const load = () => {
      unwrap(s.api.GET('/api/v1/emergency-brake'))
        .then((b) => alive && setBrake(b as Brake))
        .catch(() => undefined);
      unwrap(s.api.GET('/api/v1/decisions/count'))
        .then((c) => alive && setCount((c as { count?: number }).count ?? 0))
        .catch(() => undefined);
    };
    load();
    const id = window.setInterval(load, 60000);
    const onChange = () => load();
    window.addEventListener('hive:ops-changed', onChange);
    return () => {
      alive = false;
      window.clearInterval(id);
      window.removeEventListener('hive:ops-changed', onChange);
    };
  }, [s.api, bump]);
  return { brake, count };
}

/** Avisa a casca (aviso do freio e selo do menu) que algo mudou. */
export const opsChanged = () => window.dispatchEvent(new Event('hive:ops-changed'));
